import React, { useEffect, useState } from 'react';
import { t } from '../i18n';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { signOutAdmin } from '../firebase';

export default function Navbar({ currentUser, adminUid }) {
  const { setLang, getLang } = require('../i18n');
  const location = useLocation();
  const [teamId, setTeamId] = useState(typeof window !== 'undefined' ? localStorage.getItem('teamId') : null);
  const isAdmin = !!adminUid && currentUser && currentUser.uid === adminUid;

  useEffect(() => {
    // update when route changes (covers same-tab writes + navigation)
    setTeamId(typeof window !== 'undefined' ? localStorage.getItem('teamId') : null);
  }, [location]);

  useEffect(() => {
    // keep in sync across tabs
    function onStorage(e) {
      if (e.key === 'teamId') setTeamId(e.newValue);
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  // Detect dark mode for navbar class
  const [isDark, setIsDark] = useState(false);
  useEffect(() => {
    const checkDark = () => {
      const body = document.body;
      setIsDark(body.classList.contains('dark-mode'));
    };
    checkDark();
    window.addEventListener('storage', checkDark);
    return () => window.removeEventListener('storage', checkDark);
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg ${isDark ? 'navbar-dark' : 'navbar-light'} bg-light`} style={{background: 'var(--navbar-bg)', color: 'var(--navbar-text)'}}>
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">{t('appTitle')}</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label={t('toggleNavigation')}>
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {/* Only show admin links if admin is logged in, otherwise show player links */}
            {isAdmin ? (
              <>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/admin">{t('adminDashboard')}</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/admin/map">{t('adminMap')}</NavLink>
                </li>
              </>
            ) : (
              <>
                {currentUser && teamId ? (
                  <>
                    <li className="nav-item">
                      <NavLink className="nav-link" to="/player/team">{t('team')}</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link" to="/player/map">{t('playerMap')}</NavLink>
                    </li>
                  </>
                ) : (
                  !currentUser && (
                    <li className="nav-item">
                      <NavLink className="nav-link" to="/player">{t('player')}</NavLink>
                    </li>
                  )
                )}
                {!currentUser && (
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/admin/login">{t('adminLogin')}</NavLink>
                  </li>
                )}
              </>
            )}
          </ul>

          <div className="navbar-controls">
            {/* Settings link styled as Bootstrap button, same size as logout */}
            <NavLink
              to="/settings"
              className={({isActive}) =>
                'btn btn-sm btn-outline-secondary d-flex align-items-center me-2' + (isActive ? ' active' : '')
              }
              title={t('settings')}
              aria-label={t('settings')}
              style={{fontWeight:500, gap:'0.5em', minWidth: '100px'}}
            >
              <i className="bi bi-gear" aria-hidden="true" style={{fontSize:'1.2em'}}></i>
              <span className="d-none d-md-inline">{t('settings')}</span>
            </NavLink>
            {currentUser ? (
              <>
                {/* Only show login info for named users, not anonymous */}
                {(!currentUser.isAnonymous && (currentUser.displayName || currentUser.email)) ? (
                  <div className="me-3 small text-muted" style={{wordBreak:'break-all', color:'var(--navbar-text)'}}>{t('loggedin')} <strong style={{color:'var(--navbar-text)'}}>{currentUser.displayName || currentUser.email}</strong></div>
                ) : null}
                <button className="btn btn-sm btn-outline-secondary d-flex align-items-center" style={{minWidth:'100px', gap:'0.5em'}} onClick={async ()=>{ await signOutAdmin(); }}>
                  <i className="bi bi-box-arrow-right" aria-hidden="true" style={{fontSize:'1.2em'}}></i>
                  <span className="d-none d-md-inline">{t('signOut')}</span>
                </button>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </nav>
  );
}
